export default __webpack_public_path__ + "static/media/03-note-taker-application.36b7a0e4.PNG";